import React from 'react';
import moment from 'moment';
import BorderIndicator from 'Components/UI/BorderIndicator';
import { JUMPSTART } from 'Consts/HouseholdServiceLevelCategories';
import { fullDate } from 'Consts/DateFormats';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const ESCALATION_CONFIG = {
  save: {
    color: 'red',
    text: 'Escalated to Save',
  },
  relief: {
    color: 'secondary',
    text: 'Financial Hardship Program',
  },
  other: {
    color: 'orange',
    text: 'Escalated to Other',
  },
  churned: {
    color: 'grey',
    text: 'churned',
  },
};

const SUBSCRIPTION_LEVEL_CONFIG = {
  'foundational-only': {
    color: 'darkGrey',
    text: 'Facet Foundations',
  },
  good: {
    color: 'primaryGrey',
    text: 'Core',
  },
  better: {
    color: 'primary',
    text: 'Plus',
  },
  best: {
    color: 'green',
    text: 'Complete',
  },
};

function StatusIndicator() {
  const { householdResource } = useSimpleHousehold();

  let escalationType;
  if (householdResource?.attr('churnDate')
      && householdResource?.attr('statusId')
      && +householdResource?.attr('statusId') === 4) {
    escalationType = 'churned';
  } else {
    escalationType = householdResource?.attr('escalationType');
  }
  const escalationConfig = ESCALATION_CONFIG[escalationType];

  const isEscalated = !(householdResource?.attr('escalationType') === 'notEscalated' && !householdResource?.attr('churnDate'));

  // Maintain priority order (refer to the In App Banners FRD)
  if ((householdResource?.relationship('escalate') || householdResource?.attr('churnDate'))
      && isEscalated && escalationConfig) {
    const { color, text: popover } = ESCALATION_CONFIG[escalationType];
    const time = householdResource?.attr('churnDate') || householdResource?.attr('escalationTime');
    return (
      <BorderIndicator
        color={color}
        text={moment(time).format('MM/DD/YY')}
        popover={popover}
      />
    );
  } if (householdResource?.attr('category') === JUMPSTART) {
    return (
      <BorderIndicator
        color="green"
        text={'Jumpstart Client'}
        popover="Jumpstart Client"
      />
    );
  } if (householdResource?.attr('statusId') === 1) {
    return (
      <BorderIndicator
        color="blue"
        text={moment(householdResource?.attr('createdAt')).format(fullDate)}
        popover="Client has not paid yet."
      />
    );
  } if (householdResource?.attr('serviceLevelCategory') && SUBSCRIPTION_LEVEL_CONFIG[householdResource.attr('serviceLevelCategory')]) {
    const subLevelConfig = SUBSCRIPTION_LEVEL_CONFIG[householdResource.attr('serviceLevelCategory')];
    const { color } = subLevelConfig;
    let { text } = subLevelConfig;

    if (householdResource.attr('moneyBackGuaranteeCompletedAt')) {
      text += ` - MBG ${householdResource.attr('moneyBackGuaranteeCompletedAt')}`;
    }

    return (
      <BorderIndicator
        color={color}
        text={text}
        popoverDisabled
      />
    );
  }
  return null;
}

export default StatusIndicator;
